import { render, staticRenderFns } from "./ProductLicencePeriodDetail.vue?vue&type=template&id=6a93a670&scoped=true&"
import script from "./ProductLicencePeriodDetail.vue?vue&type=script&lang=js&"
export * from "./ProductLicencePeriodDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a93a670",
  null
  
)

export default component.exports